import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/tailwind.css'
import './assets/toast.css'
import 'flag-icons/css/flag-icons.min.css'
import { themeStore } from './store/theme'
import { toast } from './utils/toast'

// Initialize theme on app start
themeStore.init()

const app = createApp(App)
app.config.globalProperties.$toast = toast
app.use(router).mount('#app')
